import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JwtService } from '../../jwt/jwt.service';
import { Router } from '@angular/router';
import { ErrorModel } from '../../common/error.model';
import { environment } from '../../../environments/environment';
import { ImageHostingService } from '../../common/api/image-hosting.service';
import { UserService } from '../../common/api/user.service';
import { ImageModel } from '../../common/model/image.model';
import { User } from '../../common/model/user/user.model';

@Component({
  selector: 'app-modify',
  templateUrl: './modify.component.html',
  styleUrls: ['./modify.component.css']
})
export class ModifyComponent implements OnInit {
  user: User = new User('', '', '', '', []);
  role = 'ROLE_USER';
  registerForm: FormGroup = new FormGroup({
    name: new FormControl('', Validators.compose([validRequired]))
  });
  image: ImageModel = new ImageModel();
  profileUrl = 'http://img.gaeasoft.io/image/4PAAZ.jpg';
  profileUpload = false;
  uploading = false;


  constructor(private userService: UserService, public jwtService: JwtService, private router: Router,
    private location: Location, private imageHostingService: ImageHostingService) { }

  ngOnInit() {

      // this.userService.getUser().subscribe(response => this.user = response.json());
      this.user.name = this.userService.getUsername();

      const pUrl = this.userService.getProfileUrl();
      if (pUrl != null && pUrl.length > 0) {
        this.profileUrl = pUrl;
        if (pUrl !== 'http://img.gaeasoft.io/image/4PAAZ.jpg') {
          this.profileUpload = true;
        }
      }
  }

  /**
   * 회원정보 수정 요청
   */
  register() {
      if (!this.registerForm.controls['name'].errors.valid) {
         alert('(이름)' + this.registerForm.controls['name'].errors.errorMsg);
        return;
      }

      let profileSinkUrl = 'http://img.gaeasoft.io/image/4PAAZ.jpg';

      if (this.image.storedFile != null && this.image.storedFile.length > 0) {
        profileSinkUrl = this.getSinkLink(this.image, 'p');
      } else if (this.profileUrl !== 'http://img.gaeasoft.io/image/4PAAZ.jpg') {
        profileSinkUrl = this.profileUrl;
      }

      this.userService.modifyUser(this.user.name, profileSinkUrl).subscribe(response => {const ret = response; if (ret.status === 200) {
                    alert('회원 정보가 수정되었습니다');
                    sessionStorage.setItem('profileUrl', profileSinkUrl);
                    sessionStorage.setItem('username', this.user.name);

                } },
                error => {
                    alert('오류가 발생했습니다. ');
                });
    }

    /**
     * 취소
     */
    back() {
      this.location.back();
    }

    /**
     * 파일 업로드 클릭
     */
    fileUploadClick() {
      document.getElementById('profileImage').click();
    }

    /**
     * 이미지 변경
     */
    imageChange($event) {
      const file: File = $event.target.files[0];
      $('#profileImage').val('');
      this.uploading = true;
      this.imageHostingService.makeProfileImage(file).subscribe(response => {
        if (response.status === 201) {
          const image = response.json();
          this.image = image;
          const images: Array<ImageModel> = [image];
          let count = 0;
          const convertCheckInterval = setInterval(() => {
              this.imageHostingService.checkConvertImage(images, 'crop', 'profile').subscribe(res => {
                if (res.status === 200) {
                  const ret = response.json();

                  if (count > 20) {
                    alert('응답시간이 초과되었습니다.');
                    clearInterval(convertCheckInterval);
                    this.uploading = false;
                  }

                  if (ret) {
                    this.profileUrl = image.profileLink;
                    this.profileUpload = true;
                    this.uploading = false;
                    clearInterval(convertCheckInterval);
                  }

                  count++;

                }
              }, error => {
                if (error.status === 401 || error.status === 403) {
                  alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
                  this.userService.logout();
                } else {
                  console.log(error);
                  alert('오류가 발생했습니다.');
                }
                this.uploading = false;
                this.profileUpload = false;
                clearInterval(convertCheckInterval);
              });
          }, 2000);
        }
      }, error => {
        if (error.status === 401 || error.status === 403) {
          alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
          this.userService.logout();
        } else {
          alert('오류가 발생했습니다.');
          this.uploading = false;
          this.profileUpload = false;
        }
      });

    }

    imageRemove() {
      this.profileUrl = 'http://img.gaeasoft.io/image/4PAAZ.jpg';
      this.profileUpload = false;
    }

    public getSinkLink(image: ImageModel , fileType: String) {

          const sinkLink = environment.convertUrl + image.storedFile.substring(0, image.storedFile.lastIndexOf('.')) +
          fileType + image.storedFile.substring(image.storedFile.lastIndexOf('.'));

          return sinkLink;

        }
}

/**
 * element 입력 여부 체크
 */
function validRequired(ele: FormControl) {

  if (ele.value === '') {
      return {
        valid: false,
        errorMsg: '필수 정보입니다.'
      };
  } else {
    return {
      valid: true,
      errorMsg: ''
    };
  }

}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/user/modify/modify.component.ts